import React, {Component} from 'react';
import { IntercomAPI } from 'react-intercom';

import HeaderComponent from "../../../shared/header/components/HeaderComponent";
import MenuBrandsComponent from "../../../menubrands/components/MenuBrandsComponent";
import HistoryComponent from "../../../thebrand/history/components/HistoryComponent";
import SimpleTitleComponent from "../../../shared/simpletitle/components/SimpleTitleComponent";
import TheBrandComponent from "../../../thebrand/brand/components/TheBrandComponent";

import "../../styles/global.scss";
import "../../../shared/style/home/HomeStyle.scss"
import MenuComponent from "../../../menu/components/MenuComponent";
import BackToBrands from "../../../shared/backtobrands/components/BackToBrands";
import FooterComponent from "../../../shared/footer/components/FooterComponent";
import SelectCollectionComponent from "../../../thebrand/collection/components/SelectCollectionComponent";
import CollectionViewComponent from "../../../thebrand/collection/components/CollectionViewComponent";
import CallToAction from "../../../shared/calltoaction/components/CallToAction";
import LoadingComponent from "../../../shared/loading/components/LoadingComponent";
import axios from "axios";

import { Route } from "react-router-dom";

const CollectionViewRender = ({ match }) => (
  <CollectionViewComponent
        sellerSlug={match.params.slug}
        collectionId={match.params.collectionId}
       />
)


class BrandPageViewComponent extends Component {

    state = {
        loading: true,
    };

    readMore(isReadMore) {
        this.setState({
            readMore: isReadMore
        });
    }

    getBrandData() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/seller/${this.props.match.params.slug}/`, this.headers)
            .then((response) => {

                var metadata = {
                  sellerName: response.data.name,
                }
                IntercomAPI('trackEvent', 'access-seller-page', metadata);
                this.setState({
                    brandData: response.data,
                    loading: false
                })
            });

    }

    componentDidMount() {
      console.log("path", this.props.location.pathname);
      console.log(this.props.match);
      console.log(this.props.match.url);
        this.getBrandData();
    }

    render() {
      const sellerSlug = this.props.match.params.slug
        return (
            <div>
                <div className="header-menu-wrapper">
                    <HeaderComponent />
                    <MenuComponent />
                </div>
                { this.state.loading ? (
                    <LoadingComponent />
                ) : (
                    <div>


                        <div className="theBrandHeaderWrapper">
                          <div className="theBrandHeader" style={{ backgroundImage: `url(${this.state.brandData.cover_image_thumbnail})`}}>
                            { this.state.brandData.logo_brand_page &&
                              <div className="logo">
                                  <img className="mask" src={`${process.env.PUBLIC_URL}/fillLogo.png`} alt="fill logo"/>
                                  <img className="brandLogo" src={`${this.state.brandData.logo_brand_page}`}
                                       alt={`${this.state.brandData.name}`}/>
                              </div>
                            }
                          </div>
                        </div>
                        <main id="main">
                            <section className="centerComponent">
                                <MenuBrandsComponent  brandSlug={sellerSlug}/>
                            </section>

                            <section className={`centerComponent ${this.className}`}>
                                <SimpleTitleComponent title={this.state.brandData.name} />
                                <div className="containerBackToBrands"> <BackToBrands /> </div>
                            </section>

                            <section className="routerBrands">
                              <div>
                                <Route exact path={this.props.match.url} render={() => (
                                  <TheBrandComponent
                                    tags={this.state.brandData.tags}
                                    info={true}
                                    brandStyleImages={this.state.brandData.the_brand.brand_style_images}
                                    theBrand={this.state.brandData.the_brand}
                                    isReadMore={this.readMore.bind(this)}
                                    readMore={this.state.readMore}
                                    seller={sellerSlug}/>
                                )}/>

                              <Route exact path={`${this.props.match.url}/collections`}
                                render={() => (
                                    <SelectCollectionComponent
                                        seller={sellerSlug}
                                       />
                                )}
                                />
                              <Route
                                  path={`/:slug/collections/:collectionId`}
                                  sellerSlug={sellerSlug}
                                  component={CollectionViewRender}/>

                              <Route exact path={`${this.props.match.url}/history`}
                                  render={() => (
                                    <HistoryComponent
                                        products={[this.state.brandData.history.lookbook_images]}
                                        history={this.state.brandData.history}
                                        tags={this.state.brandData.tags} />
                                  )}
                                  />
                              </div>
                            </section>

                            {this.state.brandData.calls_to_action[0] &&
                              <section>
                                  <CallToAction callToAction={this.state.brandData.calls_to_action[0]}/>
                              </section>
                            }
                            <FooterComponent />
                        </main>
                    </div>
                )}
            </div>
        );
    }
}

export default (BrandPageViewComponent);
